import React, {
  useState,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";
import { ButtonHollowXs } from "./ButtonComponents";
import axios from "axios";
import { server_API } from "../config";
import { TailSpin } from "react-loader-spinner";
import { ToastContainer, toast } from "react-toastify";
import useFetch from "../hooks/useFetch";

const OfferLetter = forwardRef((props, ref) => {
  const {
    companyDetails,
    offerLetterDetails,
    applicant,
    jobDetails,
    showButton,
    offerstatus
  } = props;
  const [loading, setLoading] = useState(false);

  const pdfRef = useRef(null);


  const { data: pdfData } = useFetch(`${server_API}/v2/applicant/getoffer/${companyDetails.uuid}/${applicant.offerid}`);

  useImperativeHandle(ref, () => ({
    convertToPdf,
    sendOfferLetter,
    sendOfferApproval,
  }));

  const convertToPdf = async () => {
    if (!pdfData?.url) {
      toast.error("PDF URL not available for download.");
      return;
    }

    const link = document.createElement('a');
    link.href = pdfData.url;
    link.download = 'offer-letter.pdf';
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const sendOfferLetter = async (body) => {
    setLoading(true);
    try {
      await axios.post(`${server_API}/v2/applicant/offer`, body)
      await axios.patch(`${server_API}/v2/applicant/update`, {
        uuid: applicant.uuid,
        status: "Acceptance Awaited",
        companyid: companyDetails?.uuid,
      });

      await axios.patch(`${server_API}/v2/offer/update`, {
        uuid: offerLetterDetails[0]?.uuid,
        status: "Acceptance Awaited",
        companyid: companyDetails?.uuid,
      });
    } catch (err) {
      console.error("Error sending offer letter:", err);
      toast.error("Failed to send offer letter.");
    } finally {
      setLoading(false);
    }
  };

  const sendOfferApproval = async (body) => {
    setLoading(true);
    try {
      console.log("[BUG_TRACE OfferLetter.sendOfferApproval] outgoing body", {
        body_applicant_id: body?.applicant_id,
        body_offer_letter_id: body?.offer_letter_id,
        body_candidate_name: body?.variables?.candidate_name,
        applicant_prop_uuid: applicant?.uuid,
        applicant_prop_name: applicant?.name,
        offerLetterDetails_0_uuid: offerLetterDetails?.[0]?.uuid,
        offerLetterDetails_0_applicantid: offerLetterDetails?.[0]?.applicantid,
      });
      if (
        body?.applicant_id &&
        applicant?.uuid &&
        body.applicant_id !== applicant.uuid
      ) {
        console.error(
          "[BUG_TRACE OfferLetter.sendOfferApproval] MISMATCH body.applicant_id vs applicant.uuid prop",
          { body_applicant_id: body.applicant_id, applicant_prop_uuid: applicant.uuid },
        );
      }
      if (
        body?.offer_letter_id &&
        offerLetterDetails?.[0]?.applicantid &&
        body?.applicant_id &&
        offerLetterDetails[0].applicantid !== body.applicant_id
      ) {
        console.error(
          "[BUG_TRACE OfferLetter.sendOfferApproval] MISMATCH offer_letter belongs to a different applicant",
          {
            body_applicant_id: body.applicant_id,
            offer_letter_applicantid: offerLetterDetails[0].applicantid,
            body_offer_letter_id: body.offer_letter_id,
          },
        );
      }
      await axios.post(`${server_API}/v2/offer/approve/offerletter`, body);

      await axios.patch(`${server_API}/v2/applicant/update`, {
        uuid: applicant.uuid,
        status: "Offer Letter Pending Approval",
        companyid: companyDetails?.uuid,
      });

      await axios.patch(`${server_API}/v2/offer/update`, {
        uuid: offerLetterDetails[0]?.uuid,
        status: "Approval Pending",
        companyid: companyDetails?.uuid,
      });

    } catch (err) {
      console.error("Error sending approval:", err);
      toast.error("Failed to send offer approval.");
    } finally {
      setLoading(false);
    }
  };


  return (
    <div>
      <div
        className="bg-white p-8 rounded-xl shadow-custom-shadow text-sm leading-6"
      >

        <div className="flex justify-center">
          {pdfData?.url ? (
            <iframe
              key={pdfData.url}
              src={`https://docs.google.com/gview?url=${encodeURIComponent(pdfData.url)}&embedded=true`}
              width="100%"
              height="600px"
              frameBorder="0"
              title="PDF Viewer"
            ></iframe>
          ) : (
            <div className="flex flex-col items-center justify-center">
              <TailSpin color="#148EFF" height={50} width={50} />
              <p className="mt-4 text-gray-500">Loading PDF...</p>
            </div>
          )}
        </div>

        {showButton && (
          <div
            className="float-right -mt-10"
          >
            <ButtonHollowXs text="#148EFF" color="#FFFFFF">
              {loading ? (
                <TailSpin color="#148EFF" height={20} width={20} />
              ) : (
                "Send offer letter via email"
              )}
            </ButtonHollowXs>
          </div>
        )}
        <ToastContainer
          autoClose={3000}
          toastClassName={(context) =>
            " relative flex p-1  min-h-10 rounded-[8px]  bg-white   flex-row justify-between border-2 border-[#0DCD94] overflow-hidden cursor-pointer"
          }
          bodyClassName={() =>
            "text-[14px] gap-3 flex text-[#161A21] font-medium  p-3  pr-1"
          }
        />
      </div>
    </div>
  );
});

export default OfferLetter;

export const ToastIcon = (props) => {
  const { className } = props;
  return (
    <div className="flex justify-center m-auto items-center h-8 w-8">
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g opacity="0.6">
          <path
            d="M31 15.5C31 23.7843 24.2843 30.5 16 30.5C7.71573 30.5 1 23.7843 1 15.5C1 7.21573 7.71573 0.5 16 0.5C24.2843 0.5 31 7.21573 31 15.5Z"
            fill="#0DCD94"
            fillOpacity="0.12"
          />
          <path
            d="M28 15.5001C28 22.1275 22.6274 27.5001 16 27.5001C9.37258 27.5001 4 22.1275 4 15.5001C4 8.87271 9.37258 3.50013 16 3.50013C22.6274 3.50013 28 8.87271 28 15.5001Z"
            fill="#0DCD94"
            fillOpacity="0.2"
          />
          <path
            d="M25 15.5C25 20.4706 20.9706 24.5 16 24.5C11.0294 24.5 7 20.4706 7 15.5C7 10.5295 11.0294 6.50004 16 6.50004C20.9706 6.50004 25 10.5295 25 15.5Z"
            fill="#0DCD94"
            fillOpacity="0.28"
          />
        </g>
        <g clipPath="url(#clip0_2446_60085)">
          <path
            d="M14.6719 17.4492L17.9531 14.168"
            stroke="#0DCD94"
            strokeWidth="0.820312"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.6719 14.168H17.9531V17.4492"
            stroke="#0DCD94"
            strokeWidth="0.820312"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.3125 21.2852C19.3324 21.2852 21.7813 18.8369 21.7813 15.8164C21.7813 12.7965 19.3324 10.3477 16.3125 10.3477C13.2926 10.3477 10.8438 12.7965 10.8438 15.8164C10.8438 18.8369 13.2926 21.2852 16.3125 21.2852Z"
            stroke="#0DCD94"
            strokeWidth="0.820312"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_2446_60085">
            <rect
              width="13.125"
              height="13.125"
              fill="white"
              transform="translate(9.75 9.24609)"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};
